import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
import { Clock } from 'lucide-react';

export const CompetingActivities = () => {
  const events = [
    {
      id: 1,
      type: 'Peak Shaving',
      start: '08:00',
      end: '10:00',
      requiredSoC: 80,
      capacity: 500,
      status: 'scheduled' as const,
    },
    {
      id: 2,
      type: 'Peak Shaving',
      start: '17:00',
      end: '19:00',
      requiredSoC: 75,
      capacity: 600,
      status: 'scheduled' as const,
    },
    {
      id: 3,
      type: 'Grid Services',
      start: '12:00',
      end: '13:00',
      requiredSoC: 50,
      capacity: 300,
      status: 'active' as const,
    },
  ];
  return (
    <DashboardCard>
      <div className="mb-4 text-base font-semibold">Competing Activities</div>
      <div className="flex flex-col gap-2.5 text-base">
        {events.map((event) => (
          <div
            key={event.id}
            className={[
              'rounded-md border-l-4 p-2.5',
              event.status === 'active'
                ? 'border-amber-500 bg-amber-100'
                : 'border-zinc-500 bg-zinc-100',
            ].join(' ')}
          >
            <div className="mb-1 flex items-center gap-1.5">
              <Clock size={12} />
              <span className="font-semibold">{event.type}</span>
            </div>
            <div className="text-zinc-500">
              {event.start} - {event.end}
            </div>
            <div className="mt-1 text-base">
              Required SoC: {event.requiredSoC}% | {event.capacity} kWh
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default CompetingActivities;
